import { logAssistantCopyDebug, logAssistantRebuildDebug } from './session-debug';
import type { MessageAnchor } from './message-anchor';

type AssistantDebugMessageLike = {
  timestamp?: unknown;
  firstResponseAt?: unknown;
  lastAppendedAt?: unknown;
  displayModel?: unknown;
  model?: unknown;
  segments?: unknown;
};

function normalizeString(value: unknown): string | null {
  return typeof value === 'string' ? value : null;
}

// 统一构造 assistant 调试公共字段，避免复制/重建日志反复手写同一批元信息。
export function buildAssistantDebugMeta(message: AssistantDebugMessageLike | null | undefined): Record<string, unknown> {
  return {
    timestamp: normalizeString(message?.timestamp),
    firstResponseAt: normalizeString(message?.firstResponseAt),
    lastAppendedAt: normalizeString(message?.lastAppendedAt),
    model: normalizeString(message?.displayModel) || normalizeString(message?.model),
    segmentCount: Array.isArray(message?.segments) ? message.segments.length : 0,
  };
}

// 复制专项日志当前仍保留独立分组，便于排障；后续若产品不再需要，可统一收敛回 session-reply。
export function logAssistantCopyResolve(message: AssistantDebugMessageLike | null | undefined, payload: Record<string, unknown>): void {
  logAssistantCopyDebug('assistant-copy:resolve-text', {
    ...buildAssistantDebugMeta(message),
    ...payload,
  });
}

export function logAssistantCopyWrite(message: AssistantDebugMessageLike | null | undefined, payload: Record<string, unknown>): void {
  logAssistantCopyDebug('assistant-copy:clipboard-write', {
    ...buildAssistantDebugMeta(message),
    ...payload,
  });
}

export function logAssistantRebuildMenuClick(anchor: MessageAnchor, content: string): void {
  logAssistantRebuildDebug('assistant-rebuild:user-menu-click', {
    anchorClientMessageId: anchor.clientMessageId || null,
    anchorTimestamp: anchor.timestamp || null,
    contentLength: content.length,
    contentPreview: content.slice(0, 240),
    contentTail: content.slice(-240),
  });
}

export function logAssistantRebuildUiClick(sessionId: string, agent: string, mode: string, anchor: MessageAnchor | null | undefined): void {
  logAssistantRebuildDebug('assistant-rebuild:ui-click', {
    sessionId,
    agent,
    mode,
    anchorClientMessageId: anchor?.clientMessageId || null,
    anchorTimestamp: anchor?.timestamp || null,
  });
}

export function logAssistantRebuildUiSend(sessionId: string, payload: Record<string, unknown>): void {
  logAssistantRebuildDebug('assistant-rebuild:ui-send', {
    sessionId,
    payload,
  });
}
